import {ReportPackFormFragment} from '../../schema-types/ReportPackFormFragment';

const kebabize = (str: string) =>
  str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '_' : '') + $.toLowerCase());

export const getReportPackMissingFieldError = (
  reportPack: ReportPackFormFragment,
  id: string
) => {
  /**
   * workaround so we don't have to query the BE to check if the fields are still invalid
   */
  const existingValue = (reportPack as any)?.[id];
  const stillMissing = existingValue === null || existingValue === undefined;
  const missingFields = reportPack.statusAndMissing?.missingFields ?? [];
  return missingFields.includes(kebabize(id)) && stillMissing;
};
